import type { StatusTone } from "@/lib/status";
import type { ShareStatus } from "@/types";

/** The single share-status display mapping (Staff Chat Brief 01 §4.4): raw
 *  status strings never render — same rule as the client app's chipForStatus. */
export function shareStatusToPill(status: ShareStatus): { label: string; tone: StatusTone } {
  switch (status) {
    case "draft":
      return { label: "Draft", tone: "info-soft" };
    case "sent":
      return { label: "Sent", tone: "info" };
    case "viewed":
      return { label: "Viewed", tone: "info" };
    case "approved":
      return { label: "Approved", tone: "success" };
    case "changes_requested":
      return { label: "Changes requested", tone: "danger" };
    case "superseded":
      return { label: "Superseded", tone: "neutral" };
    case "withdrawn":
      return { label: "Withdrawn", tone: "neutral" };
  }
}

/** File-size display for share cards; 0/unset renders as an em dash. */
export function formatBytes(n: number | null | undefined): string {
  if (!n || n <= 0) return "—";
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${Math.round(n / 1024)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}